import { render, staticRenderFns } from "./HeaderPopular.vue?vue&type=template&id=7f7d459c&scoped=true&"
import script from "./HeaderPopular.vue?vue&type=script&lang=js&"
export * from "./HeaderPopular.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPopular.vue?vue&type=style&index=0&id=7f7d459c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d459c",
  null
  
)

export default component.exports